module.exports = __webpack_public_path__ + "img/nsw-light.d1a2ecd4.svg";